import { ActionContext } from "vuex";
import { getStoreAccessors } from "vuex-typescript";
import { State as RootState } from "../state";
import { UserState } from "./userState";
import { UserInfo } from "../../_models/userInfo"
import { EnterpriseInfo } from '../../_models/enterpriseInfo'
import { InstituteInfo } from "../../_models/instituteInfo"
import { UserResetPassInfo } from "../../_models/userResetPasswordInfo"
import { dataService } from "../../_services"
import { userService } from "../../_services"
import { router } from '../../_router';
import { UserSignUpInfo } from "../../_models/userSignUpInfo";
import { StudentInfo } from "../../_models/studentInfo";
import { DocAutorizzazioneInfo } from "../../_models/docAutorizzazioneInfo";
import { DocNominaResponsabileInfo } from '@/_models/docNominaResponsabileInfo';
import { RichiestaAlternanza } from '@/_models/richiestaAlternanza';
import { RichiestaTirEstivi } from '@/_models/richiestaTirEstivi';
import { RichiestaTirFormativi } from '@/_models/richiestaTirFormativi';
import { ReportVisiteInfo } from '@/_models/reportVisiteInfo';
import { DocAttestatoFinale } from '@/_models/docAttestatoFinale';
import { AttivitaIstituto } from '@/_models/attivitaIstituto';
import { PropostaLavoroInfo } from '@/_models/propostaLavoroInfo';
import { ContattoAziendaInfo } from "@/_models/contattoAzienda";
import { NotaAzienda } from "@/_models/notaAzienda";

type UserContext = ActionContext<UserState, RootState>
const getDefaultState = () => {
    return {
        info: null,
        enterpriseInfo: null,
        instituteInfo: null,
        studentInfo: null
    }
}

export const user = {
    namespaced: true,

    state: getDefaultState(),

    getters: {
        getUserInfo(state: UserState) {
            return state.info
        },
        getEnterpriseInfo(state: UserState) {
            return state.enterpriseInfo
        },
        getInstituteInfo(state: UserState) {
            return state.instituteInfo
        },
        getStudentInfo(state: UserState) {
            return state.studentInfo
        }
    },

    mutations: {
        editUserInfo(state: UserState, userInfo: UserInfo): void {
            state.info = userInfo;
        },
        editEnterpriseInfo(state: UserState, enterpriseInfo: EnterpriseInfo): void {
            state.enterpriseInfo = enterpriseInfo;
        },
        editInstituteInfo(state: UserState, instituteInfo: InstituteInfo): void {
            state.instituteInfo = instituteInfo;
        },
        editStudentInfo(state: UserState, studentInfo: StudentInfo): void {
            state.studentInfo = studentInfo;
        },
        clearState(state: UserState) {
            Object.assign(state, getDefaultState())
        }
    },

    actions: {
        setUserInfo(context: UserContext, payload: { idUtente: number, tipoSoggetto: number, username: string }) {
            return new Promise<UserInfo>((resolve, reject) => {
                var result: UserInfo;
                var check: UserInfo | null = readUserInfo(context)
                var roles: number[] = []
                var descRoles: string[] = []
                if (check === null || check === undefined) {
                    dataService.getUserRole(payload.username)
                        .then(res => {
                            res.forEach((element: any) => {
                                roles.push(element.IdRuolo)
                                descRoles.push(element.Descrizione)
                            });
                            dataService.getUserInfo(payload.idUtente, payload.tipoSoggetto)
                                .then(response => {
                                    if (payload.tipoSoggetto === 2) {
                                        result = {
                                            tipoSoggetto: response.data.IdTipoSoggetto,
                                            ruoloUtente: roles,
                                            descrizioneRuolo: descRoles,
                                            nomeUtente: response.data.Nome,
                                            cognomeUtente: response.data.Cognome,
                                            indirizzoUtente: response.data.Indirizzo,
                                            telefono1Utente: response.data.Telefono1,
                                            telefono2Utente: response.data.Telefono2,
                                            cod: response.data.CodiceFiscale,
                                            dataNascita: response.data.DataNascita,
                                            luogoNascita: response.data.LuogoNascita,
                                            emailUtente: response.data.Email,
                                            pecUtente: response.data.EmailPec,
                                            comuneUtente: response.data.Localita,
                                            provinciaUtente: response.data.IdProvincia,
                                            entità: response.data.Denominazione,
                                            codEntità: response.data.IdIstituto,
                                            idCap: response.data.IdCap,
                                            idUtente: response.data.Id,
                                            cap: response.data.Cap,
                                            username: payload.username
                                        }
                                    } else if (payload.tipoSoggetto === 3) {
                                        result = {
                                            tipoSoggetto: response.data.IdTipoSoggetto,
                                            ruoloUtente: roles,
                                            descrizioneRuolo: descRoles,
                                            nomeUtente: response.data.Nome,
                                            cognomeUtente: response.data.Cognome,
                                            indirizzoUtente: response.data.Indirizzo,
                                            telefono1Utente: response.data.Telefono1,
                                            telefono2Utente: response.data.Telefono2,
                                            cod: response.data.CodiceFiscale,
                                            dataNascita: response.data.DataNascita,
                                            luogoNascita: response.data.LuogoNascita,
                                            emailUtente: response.data.Email,
                                            pecUtente: response.data.EmailPec,
                                            comuneUtente: response.data.Localita,
                                            provinciaUtente: response.data.IdProvincia,
                                            entità: response.data.Denominazione,
                                            codEntità: response.data.IdAzienda,
                                            idCap: response.data.IdCap,
                                            idUtente: response.data.Id,
                                            cap: response.data.Cap,
                                            username: payload.username
                                        }
                                    }
                                    // if (payload.tipoSoggetto == 4) {
                                    // commitSetStudentInfo(context, resultAllievi)
                                    // resolve(resultAllievi)
                                    // } else {
                                    commitSetUserInfo(context, result)
                                    resolve(result)
                                    // }
                                }).catch((error) => {
                                    reject(error)
                                })
                        }).catch(error => {
                            reject(error)
                        })
                } else {
                    resolve(check)
                }
            })
        },
        setStudentInfo(context: UserContext, payload: { idUtente: number, tipoSoggetto: number, username: string }) {
            return new Promise<StudentInfo>((resolve, reject) => {
                var resultAllievi: StudentInfo;
                var check: StudentInfo | null = readStudentInfo(context)
                var roles: number[] = []
                var descRoles: string[] = []
                if (check === null || check === undefined) {
                    dataService.getUserRole(payload.username)
                        .then(res => {
                            res.forEach((element: any) => {
                                roles.push(element.IdRuolo)
                                descRoles.push(element.Nome)
                            });
                            dataService.getUserInfo(payload.idUtente, payload.tipoSoggetto)
                                .then(response => {
                                    resultAllievi = {
                                        tipoSoggetto: response.data.IdTipoSoggetto,
                                        matricola: response.data.Matricola,
                                        ruoloUtente: roles,
                                        descrizioneRuolo: descRoles,
                                        nomeUtente: response.data.Nome,
                                        cognomeUtente: response.data.Cognome,
                                        indirizzoUtente: response.data.Indirizzo,
                                        telefono1Utente: response.data.Telefono1,
                                        telefono2Utente: response.data.Telefono2,
                                        cod: response.data.CodiceFiscale,
                                        dataNascita: response.data.DataNascita,
                                        luogoNascita: response.data.LuogoNascita,
                                        emailUtente: response.data.Email,
                                        pecUtente: response.data.EmailPec,
                                        comuneUtente: response.data.Localita,
                                        provinciaUtente: response.data.IdProvincia,
                                        entità: response.data.Denominazione,
                                        codEntità: response.data.IdIstituto,
                                        idCap: response.data.IdCap,
                                        idUtente: response.data.Id,
                                        cap: response.data.Cap,
                                        username: payload.username,
                                        classe: response.data.AnnoCorso + ' ' + response.data.Sezione,
                                        idClasse: response.data.IdClasse,
                                        idNazioneNascita: response.data.IdNazioneNascita,
                                        diplomato: response.data.Diplomato,
                                        dataDiploma: response.data.DataDiploma,
                                        urlCV: response.data.Url
                                    }
                                    commitSetStudentInfo(context, resultAllievi)
                                    resolve(resultAllievi)
                                }).catch((error) => {
                                    reject(error)
                                })
                        }).catch(error => {
                            reject(error)
                        })
                } else {
                    resolve(check)
                }
            })
        },
        editStudentInfo(context: UserContext, payload: StudentInfo) {
            return new Promise<string>((resolve, reject) => {
                //chiamata per ottenere nome comune e provincia in base a idcap salvato
                var updateInfo: StudentInfo = {
                    tipoSoggetto: payload.tipoSoggetto,
                    matricola: payload.matricola,
                    ruoloUtente: payload.ruoloUtente,
                    descrizioneRuolo: payload.descrizioneRuolo,
                    nomeUtente: payload.nomeUtente,
                    cognomeUtente: payload.cognomeUtente,
                    indirizzoUtente: payload.indirizzoUtente,
                    telefono1Utente: payload.telefono1Utente,
                    telefono2Utente: payload.telefono2Utente,
                    cod: payload.cod,
                    dataNascita: payload.dataNascita,
                    luogoNascita: payload.luogoNascita,
                    emailUtente: payload.emailUtente,
                    pecUtente: payload.pecUtente,
                    comuneUtente: payload.cognomeUtente,
                    provinciaUtente: payload.provinciaUtente,
                    entità: payload.entità,
                    codEntità: payload.codEntità,
                    idCap: payload.idCap,
                    idUtente: payload.idUtente,
                    cap: payload.cap,
                    username: payload.username,
                    classe: payload.classe,
                    idClasse: payload.idClasse,
                    idNazioneNascita: payload.idNazioneNascita,
                    diplomato: false,
                    dataDiploma: "",
                    urlCV: ''
                }

                userService.editStudentInfo(updateInfo).then(() => {
                    commitEditStudentInfo(context, updateInfo)
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        editUserInfo(context: UserContext, payload: UserInfo) {
            return new Promise<string>((resolve, reject) => {
                //chiamata per ottenere nome comune e provincia in base a idcap salvato
                var updateInfo: UserInfo = {
                    tipoSoggetto: payload.tipoSoggetto,
                    ruoloUtente: payload.ruoloUtente,
                    descrizioneRuolo: payload.descrizioneRuolo,
                    nomeUtente: payload.nomeUtente,
                    cognomeUtente: payload.cognomeUtente,
                    indirizzoUtente: payload.indirizzoUtente,
                    telefono1Utente: payload.telefono1Utente,
                    telefono2Utente: payload.telefono2Utente,
                    cod: payload.cod,
                    dataNascita: payload.dataNascita,
                    luogoNascita: payload.luogoNascita,
                    emailUtente: payload.emailUtente,
                    pecUtente: payload.pecUtente,
                    comuneUtente: payload.cognomeUtente,
                    provinciaUtente: payload.provinciaUtente,
                    entità: payload.entità,
                    codEntità: payload.codEntità,
                    idCap: payload.idCap,
                    idUtente: payload.idUtente,
                    cap: payload.cap,
                    username: payload.username
                }
                userService.editUserInfo(updateInfo).then(() => {
                    commitEditUserInfo(context, updateInfo)
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        setEnterpriseInfo(context: UserContext) {
            return new Promise<EnterpriseInfo>((resolve, reject) => {
                var result: EnterpriseInfo;
                var user: UserInfo | null = readUserInfo(context);
                var idAzienda: number;
                var comuneAzienda: string
                var provinciaAzienda: string
                var check: EnterpriseInfo | null = readEnterpriseInfo(context)
                if (check === null || check === undefined) {
                    idAzienda = user.codEntità;
                    dataService.getEnterpriseInfo(idAzienda)
                        .then(response => {
                            if (response.data.IdCap === 0) { //idCap Estero
                                comuneAzienda = response.data.ComuneAzienda
                                provinciaAzienda = response.data.ProvinciaAzienda
                            } else {
                                comuneAzienda = response.data.Localita
                                provinciaAzienda = response.data.IdProvincia
                            }
                            result = {
                                idAzienda: response.data.Id,
                                denominazioneAzienda: response.data.Denominazione,
                                titolo: response.data.Titolo,
                                cognomeRappresentanteAzienda: response.data.CognomeRappresentante,
                                nomeRappresentanteAzienda: response.data.NomeRappresentante,
                                dataNascitaRappresentante: response.data.DataNascitaRappresentante,
                                statoNascitaRappresentante: response.data.PaeseNascitaRappresentante,
                                luogoNascitaRappresentante: response.data.LuogoNascitaRappresentante,
                                // comuneAzienda: response.data.Localita,
                                comuneAzienda: comuneAzienda,
                                // provinciaAzienda: response.data.IdProvincia,
                                provinciaAzienda: provinciaAzienda,
                                idCapComuneAzienda: response.data.IdCap,
                                indirizzoAzienda: response.data.Indirizzo,
                                telefono1Azienda: response.data.Telefono1,
                                telefono2Azienda: response.data.Telefono2,
                                faxAzienda: response.data.Fax,
                                emailAzienda: response.data.EMail,
                                pecAzienda: response.data.EMailPec,
                                sitoAzienda: response.data.SitoWeb,
                                attivitàAzienda: response.data.AttivitàSvolta,
                                dipendentiAzienda: response.data.NumeroDipendenti,
                                committenzaAzienda: response.data.IdCommittenza,
                                associata: response.data.Associata,
                                artigiana: response.data.AziendaArtigiana,
                                pIva: response.data.PIva,
                                codAzienda: response.data.CodiceFiscale,
                                idAteco: response.data.IdAteco,
                                // idIstat: response.data.IdIstat,
                                // codAteco: response.data.CodAteco,
                                // codIstat: response.data.CodIstat,
                                descrizioneAteco: response.data.CodAteco + "-" + response.data.DescrizioneAteco,
                                descrizioneIstat: response.data.CodIstat + "-" + response.data.DescrizioneIstat,
                                cap: response.data.Cap,
                                idNazioneAzienda: response.data.IdNazioneAzienda,
                                nazioneAzienda: response.data.NazioneAzienda,
                                idStatoUtente: response.data.IdStato,
                                codRappresentate: response.data.CFRappresentante,
                                confCommercio: response.data.ConfCommercio,
                                altraAssociazione: response.data.HasAltraAssociazione
                            }
                            commitSetEnterpriseInfo(context, result)
                            resolve(result)
                        }).catch((error) => {
                            reject(error)
                        })
                } else {
                    resolve(check)
                }
            })
        },
        editEnterpriseInfo(context: UserContext, payload: EnterpriseInfo) {
            return new Promise<string>((resolve, reject) => {
                var updateInfo: EnterpriseInfo = {
                    idAzienda: payload.idAzienda,
                    denominazioneAzienda: payload.denominazioneAzienda,
                    titolo: payload.titolo,
                    cognomeRappresentanteAzienda: payload.cognomeRappresentanteAzienda,
                    nomeRappresentanteAzienda: payload.nomeRappresentanteAzienda,
                    dataNascitaRappresentante: payload.dataNascitaRappresentante,
                    statoNascitaRappresentante: payload.statoNascitaRappresentante,
                    luogoNascitaRappresentante: payload.luogoNascitaRappresentante,
                    comuneAzienda: payload.comuneAzienda,
                    idCapComuneAzienda: payload.idCapComuneAzienda,
                    provinciaAzienda: payload.provinciaAzienda,
                    indirizzoAzienda: payload.indirizzoAzienda,
                    telefono1Azienda: payload.telefono1Azienda,
                    telefono2Azienda: payload.telefono2Azienda,
                    faxAzienda: payload.faxAzienda,
                    emailAzienda: payload.emailAzienda,
                    pecAzienda: payload.pecAzienda,
                    sitoAzienda: payload.sitoAzienda,
                    attivitàAzienda: payload.attivitàAzienda,
                    dipendentiAzienda: payload.dipendentiAzienda,
                    committenzaAzienda: payload.committenzaAzienda,
                    associata: payload.associata,
                    artigiana: payload.artigiana,
                    pIva: payload.pIva,
                    codAzienda: payload.codAzienda,
                    idAteco: payload.idAteco,
                    // idIstat: payload.idIstat,
                    // codAteco: payload.codAteco,
                    // codIstat: payload.codIstat,
                    descrizioneAteco: payload.descrizioneAteco,
                    descrizioneIstat: payload.descrizioneIstat,
                    cap: payload.cap,
                    idNazioneAzienda: payload.idNazioneAzienda,
                    nazioneAzienda: payload.nazioneAzienda,
                    idStatoUtente: 0,
                    codRappresentate: payload.codRappresentate,
                    confCommercio: payload.confCommercio,
                    altraAssociazione: payload.altraAssociazione
                }
                userService.editEnterpriseInfo(updateInfo).then(() => {
                    commitEditEnterpriseInfo(context, updateInfo)
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        setInstituteInfo(context: UserContext) {
            return new Promise<InstituteInfo>((resolve, reject) => {
                var result: InstituteInfo;
                var user: UserInfo | null = readUserInfo(context);
                if (user === null || user === undefined) {
                    user = readStudentInfo(context)
                }
                var idIstituto: number;
                var check: InstituteInfo | null = readInstituteInfo(context)
                if (check === null || check === undefined) {
                    idIstituto = user.codEntità;
                    dataService.getInstituteInfo(idIstituto)
                        .then(response => {
                            result = {
                                id: response.data.Id,
                                ragioneSocialeIstituto: response.data.Denominazione,
                                indirizzoIstituto: response.data.Indirizzo,
                                capComuneIstituto: response.data.IdCap,
                                provinciaIstituto: response.data.IdProvincia,
                                nazioneIstituto: response.data.IdNazione,
                                comuneIstituto: response.data.Localita,
                                telefono1Istituto: response.data.Telefono1,
                                telefono2Istituto: response.data.Telefono2,
                                emailIstituto: response.data.EMail,
                                pecIstituto: response.data.EMailPec,
                                codIstituto: response.data.CodiceFiscale,
                                codMinisterialeIstituto: response.data.CodiceMinisteriale,
                                dirigenteIstituto: response.data.Dirigente
                            }
                            commitSetInstituteInfo(context, result)
                            resolve(result)
                        }).catch(error => {
                            reject(error)
                        })
                } else {
                    resolve(check)
                }
            })
        },
        editInstituteInfo(context: UserContext, payload: InstituteInfo) {
            return new Promise<string>((resolve, reject) => {
                var updateInfo: InstituteInfo = {
                    id: payload.id,
                    ragioneSocialeIstituto: payload.ragioneSocialeIstituto,
                    indirizzoIstituto: payload.indirizzoIstituto,
                    capComuneIstituto: payload.capComuneIstituto,
                    provinciaIstituto: payload.provinciaIstituto,
                    nazioneIstituto: payload.nazioneIstituto,
                    comuneIstituto: payload.comuneIstituto,
                    telefono1Istituto: payload.telefono1Istituto,
                    telefono2Istituto: payload.telefono2Istituto,
                    emailIstituto: payload.emailIstituto,
                    pecIstituto: payload.pecIstituto,
                    codIstituto: payload.codIstituto,
                    codMinisterialeIstituto: payload.codMinisterialeIstituto,
                    dirigenteIstituto: payload.dirigenteIstituto
                }
                userService.editInstituteInfo(updateInfo).then(() => {
                    commitEditInstituteInfo(context, updateInfo)
                    resolve("ok")
                }).catch(error => {
                    reject(error);
                })
            })
        },
        clearState(context: UserContext) {
            commitClearState(context)
        },
        sendResetLink(context: UserContext, payload: UserResetPassInfo) {
            return new Promise<string>((resolve, reject) => {
                userService.sendResetLink(payload).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        resetPassword(context: UserContext, payload: { token: string, password: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.resetPassword(payload.token, payload.password).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        createUser(context: UserContext, payload: UserSignUpInfo) {
            return new Promise<string>((resolve, reject) => {
                userService.createUser(payload).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        submitAuthorizationDoc(context: UserContext, payload: { info: DocAutorizzazioneInfo, idAllievo: number, idAnnoScolastico: number, idIstituto: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.submitAuthorizationDoc(payload.info, payload.idAllievo, payload.idAnnoScolastico, payload.idIstituto).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        submitResponsabileDatiDoc(context: UserContext, info: DocNominaResponsabileInfo) {
            return new Promise<string>((resolve, reject) => {
                userService.submitResponsabileDatiDoc(info.firmaUno, info.firmaDue, info.idAzienda, info.idIstituto, info.dataDocumento, info.nomeAzienda, info.nomeIstituto)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        confirmResponsabileDatiDoc(context: UserContext, idDoc: number) {
            return new Promise<string>((resolve, reject) => {
                userService.confirmResponsabileDatiDoc(idDoc)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        refuseResponsabileDatiDoc(context: UserContext, idDoc: number) {
            return new Promise<string>((resolve, reject) => {
                userService.refuseResponsabileDatiDoc(idDoc)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        updateResponsabileDatiDoc(context: UserContext, info: DocNominaResponsabileInfo) {
            return new Promise<string>((resolve, reject) => {
                userService.updateResponsabileDatiDoc(info.firmaUno, info.firmaDue, info.idAzienda, info.idIstituto, info.dataDocumento, info.nomeAzienda, info.nomeIstituto, info.idDoc)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        confirmAutorizzazioneStudentiDoc(context: UserContext, idDoc: number) {
            return new Promise<string>((resolve, reject) => {
                userService.confirmAutorizzazioneStudentiDoc(idDoc)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        refuseAutorizzazioneStudentiDoc(context: UserContext, idDoc: number) {
            return new Promise<string>((resolve, reject) => {
                userService.refuseAutorizzazioneStudentiDoc(idDoc)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        updateAutorizzazioneStudentiDoc(context: UserContext, info: DocAutorizzazioneInfo) {
            return new Promise<string>((resolve, reject) => {
                userService.updateAutorizzazioneStudentiDoc(info)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        submitRichiestaAlternanza(context: UserContext, elements: RichiestaAlternanza) {
            return new Promise<string>((resolve, reject) => {
                userService.submitRichiestaAlternanza(elements)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        subscribeToActivities(context: UserContext, payload: { idIstituto: number, idAnnoScolastico: number }) {
            var enterpriseInfo: EnterpriseInfo = readEnterpriseInfo(context);
            return new Promise<number>((resolve, reject) => {
                userService.subscribeToActivities(enterpriseInfo.idAzienda, payload.idIstituto, payload.idAnnoScolastico)
                    .then((result) => {
                        resolve(result.Id)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        subscribeToAlternanza(context: UserContext, idAziendaIstitutoAnno: number) {
            return new Promise<string>((resolve, reject) => {
                userService.subscribeToAlternanza(idAziendaIstitutoAnno)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        refuseDoc(context: UserContext, payload: { docType: string, email: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.refuseDoc(payload.docType, payload.email)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        confirmDoc(context: UserContext, payload: { docType: string, email: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.confirmDoc(payload.docType, payload.email)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        deleteRichiestaAlternanza(context: UserContext, idRichiesta: number) {
            return new Promise<string>((resolve, reject) => {
                userService.deleteRichiestaAlternanza(idRichiesta)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        updateRichiestaAlternanza(context: UserContext, richiestaInfo: RichiestaAlternanza) {
            return new Promise<string>((resolve, reject) => {
                userService.updateRichiestaAlternanza(richiestaInfo)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        addUserRole(context: UserContext, payload: { username: string, newRole: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.addUserRole(payload.username, payload.newRole)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        updateUserRole(context: UserContext, payload: { username: string, newRole: number, oldRole: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.updateUserRole(payload.username, payload.newRole, payload.oldRole)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        deleteUserRole(context: UserContext, payload: { username: string, role: number, idUtente: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.deleteUserRole(payload.username, payload.role, payload.idUtente)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        deleteAssegnazioneIndirizzoStudio(context: UserContext, payload: { idUtente: number, idIndirizzoStudio: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.deleteAssegnazioneIndirizzoStudio(payload.idUtente, payload.idIndirizzoStudio)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        deleteAssegnazioneArticolazione(context: UserContext, payload: { idUtente: number, idArticolazione: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.deleteAssegnazioneArticolazione(payload.idUtente, payload.idArticolazione)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        confirmAssegnazioneIndirizzoStudio(context: UserContext, payload: { idUtente: number, idIndirizzoStudio: number, idOldIndirizzoStudio: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.confirmAssegnazioneIndirizzoStudio(payload.idUtente, payload.idIndirizzoStudio, payload.idOldIndirizzoStudio)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        confirmAssegnazioneArticolazione(context: UserContext, payload: { idUtente: number, idArticolazione: string, idOldArticolazione: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.confirmAssegnazioneArticolazione(payload.idUtente, payload.idArticolazione, payload.idOldArticolazione)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        assignTutorToAllievo(context: UserContext, payload: { idIstituto: number, idAnnoScolastico: number, idAllievo: number, idTutor: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.assignTutorToAllievo(payload.idIstituto, payload.idAnnoScolastico, payload.idAllievo, payload.idTutor)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        changeStudentActivityStatus(context: UserContext, payload: { idAllievo: number, idIstitutoAnnoScolastico: number, idClasse: number, gestioneAlternanza: boolean }) {
            return new Promise<string>((resolve, reject) => {
                userService.changeStudentActivityStatus(payload.idAllievo, payload.idIstitutoAnnoScolastico, payload.idClasse, payload.gestioneAlternanza)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        assignAllievoToAzienda(context: UserContext, payload: { idIstituto: number, idAnnoScolastico: number, idAllievo: number, idTutor: number, idRichiesta: number, idRichiestaOld: number, attivita: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.assignAllievoToAzienda(payload.idIstituto, payload.idAnnoScolastico, payload.idAllievo, payload.idTutor, payload.idRichiesta, payload.idRichiestaOld, payload.attivita)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        subscribeToColloqui(context: UserContext, idAziendaIstitutoAnno: number) {
            return new Promise<string>((resolve, reject) => {
                userService.subscribeToColloqui(idAziendaIstitutoAnno)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        registerSchedule(context: UserContext, payload: { idAllievo: number, idAzienda: number, idIstituto: number, idAnnoScolastico: number, idArticolazione: string, nTurno: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.registerSchedule(payload.idAllievo, payload.idAzienda, payload.idIstituto, payload.idAnnoScolastico, payload.idArticolazione, payload.nTurno)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        sendQuestionarioCV(context: UserContext, payload: { idSchedulazione: number, nomeSelezionatore: string, cognomeSelezionatore: string, esito: number, note: string, posizioneRichiesta: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.sendQuestionarioCV(payload.idSchedulazione, payload.nomeSelezionatore, payload.cognomeSelezionatore, payload.esito, payload.note, payload.posizioneRichiesta)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        sendLinkColloquioCV(context: UserContext, payload: { nomeAllievo: string, cognomeAllievo: string, emailAllievo: string, turno: string, nomeAzienda: string, emailAzienda: string, linkColloquio: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.sendLinkColloquioCV(payload.nomeAllievo, payload.cognomeAllievo, payload.emailAllievo, payload.turno, payload.nomeAzienda, payload.emailAzienda, payload.linkColloquio)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        subscribeToTirEstivi(context: UserContext, idAziendaIstitutoAnno: number) {
            return new Promise<string>((resolve, reject) => {
                userService.subscribeToTirEstivi(idAziendaIstitutoAnno)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        submitRichiestaTirEstivo(context: UserContext, elements: RichiestaTirEstivi) {
            return new Promise<string>((resolve, reject) => {
                userService.submitRichiestaTirEstivo(elements)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        deleteRichiestaTirEstivo(context: UserContext, idRichiesta: number) {
            return new Promise<string>((resolve, reject) => {
                userService.deleteRichiestaTirEstivo(idRichiesta)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        updateRichiestaTirEstivo(context: UserContext, richiestaInfo: RichiestaTirEstivi) {
            return new Promise<string>((resolve, reject) => {
                userService.updateRichiestaTirEstivo(richiestaInfo)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        assignAllievoToAziendaTirEstivo(context: UserContext, payload: { idIstituto: number, idAnnoScolastico: number, idAllievo: number, idTutor: number, idRichiesta: number, idRichiestaOld: number, attivita: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.assignAllievoToAziendaTirEstivo(payload.idIstituto, payload.idAnnoScolastico, payload.idAllievo, payload.idTutor, payload.idRichiesta, payload.idRichiestaOld, payload.attivita)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        updatePreAssegnamentoTirEstivo(context: UserContext, payload: { dataInizioPeriodo: string, dataFinePeriodo: string, oraInizioMattino: string, oraFineMattino: string, oraInizioPomeriggio: string, oraFinePomeriggio: string, idTutorAziendale: number, facilitazioni: string, idRichiesta: number, attivita: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.updatePreAssegnamentoTirEstivo(payload.dataInizioPeriodo, payload.dataFinePeriodo, payload.oraInizioMattino, payload.oraFineMattino, payload.oraInizioPomeriggio, payload.oraFinePomeriggio, payload.idTutorAziendale, payload.facilitazioni, payload.idRichiesta, payload.attivita)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        updatePreAssegnamentoAlternanza(context: UserContext, payload: { dataInizioPeriodo: string, dataFinePeriodo: string, oraInizioMattino: string, oraFineMattino: string, oraInizioPomeriggio: string, oraFinePomeriggio: string, idTutorAziendale: number, facilitazioni: string, idRichiesta: number, attivita: string, hasSecondPeriod: boolean, dataInizioSecondoPeriodo: string, dataFineSecondoPeriodo: string, oraInizioMattinoSecondoPeriodo: string, oraFineMattinoSecondoPeriodo: string, oraInizioPomeriggioSecondoPeriodo: string, oraFinePomeriggioSecondoPeriodo: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.updatePreAssegnamentoAlternanza(payload.dataInizioPeriodo, payload.dataFinePeriodo, payload.oraInizioMattino, payload.oraFineMattino, payload.oraInizioPomeriggio, payload.oraFinePomeriggio, payload.idTutorAziendale, payload.facilitazioni, payload.idRichiesta, payload.attivita, payload.hasSecondPeriod, payload.dataInizioSecondoPeriodo, payload.dataFineSecondoPeriodo, payload.oraInizioMattinoSecondoPeriodo, payload.oraFineMattinoSecondoPeriodo, payload.oraInizioPomeriggioSecondoPeriodo, payload.oraFinePomeriggioSecondoPeriodo)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        assignTutorFormToRichiestaTirEstivo(context: UserContext, payload: { idIstituto: number, idAnnoScolastico: number, idAllievo: number, idTutor: number, idTutorForm: number, idRichiesta: number, attivita: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.assignTutorFormToRichiestaTirEstivo(payload.idIstituto, payload.idAnnoScolastico, payload.idAllievo, payload.idTutor, payload.idTutorForm, payload.idRichiesta, payload.attivita)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        confirmAbbinamento(context: UserContext, payload: { idRichiesta: number, activityType: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.confirmAbbinamento(payload.idRichiesta, payload.activityType)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        generaDocumenti(context: UserContext, payload: { idRichiesta: number, activityType: string, numeroProtocollazione: string, dataProtocollazione: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.generaDocumenti(payload.idRichiesta, payload.activityType, payload.numeroProtocollazione, payload.dataProtocollazione)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        signConvenzione(context: UserContext, payload: { idConvenzione: number, firmaAzienda: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.signConvenzione(payload.idConvenzione, payload.firmaAzienda)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        signProgettoOrientamento(context: UserContext, payload: { idProgettoOrientamento: number, firma: string, firmaDue: string, soggetto: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.signProgettoOrientamento(payload.idProgettoOrientamento, payload.firma, payload.firmaDue, payload.soggetto)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        confirmConvenzione(context: UserContext, payload: { idConvenzione: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.confirmConvenzione(payload.idConvenzione)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        refuseConvenzione(context: UserContext, payload: { idConvenzione: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.refuseConvenzione(payload.idConvenzione)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        confirmProgettoOrientamento(context: UserContext, payload: { idProgettoOrientamento: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.confirmProgettoOrientamento(payload.idProgettoOrientamento)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        refuseProgettoOrientamento(context: UserContext, payload: { idProgettoOrientamento: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.refuseProgettoOrientamento(payload.idProgettoOrientamento)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        confirmPercorsoFormativo(context: UserContext, payload: { idPercorsoFormativo: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.confirmPercorsoFormativo(payload.idPercorsoFormativo)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        refusePercorsoFormativo(context: UserContext, payload: { idPercorsoFormativo: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.refusePercorsoFormativo(payload.idPercorsoFormativo)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        subscribeToTirFormativi(context: UserContext, idAziendaIstitutoAnno: number) {
            return new Promise<string>((resolve, reject) => {
                userService.subscribeToTirFormativi(idAziendaIstitutoAnno)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        submitRichiestaTirFormativo(context: UserContext, elements: RichiestaTirFormativi) {
            return new Promise<string>((resolve, reject) => {
                userService.submitRichiestaTirFormativo(elements)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        assignAllievoToAziendaTirFormativo(context: UserContext, payload: { idIstituto: number, idAnnoScolastico: number, idAllievo: number, idTutor: number, idRichiesta: number, idRichiestaOld: number, attivita: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.assignAllievoToAziendaTirFormativo(payload.idIstituto, payload.idAnnoScolastico, payload.idAllievo, payload.idTutor, payload.idRichiesta, payload.idRichiestaOld, payload.attivita)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        assignTutorFormToRichiestaTirFormativo(context: UserContext, payload: { idIstituto: number, idAnnoScolastico: number, idAllievo: number, idTutor: number, idTutorForm: number, idRichiesta: number, attivita: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.assignTutorFormToRichiestaTirFormativo(payload.idIstituto, payload.idAnnoScolastico, payload.idAllievo, payload.idTutor, payload.idTutorForm, payload.idRichiesta, payload.attivita)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        saveAssegnazioneAllievoAzienda(context: UserContext, payload: { idRichiesta: number, attivita: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.saveAssegnazioneAllievoAzienda(payload.idRichiesta, payload.attivita)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        refusePreAbbinamento(context: UserContext, payload: { idRichiesta: number, attivita: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.refusePreAbbinamento(payload.idRichiesta, payload.attivita)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        createReportVisita(context: UserContext, reportVisita: ReportVisiteInfo) {
            return new Promise<string>((resolve, reject) => {
                userService.createReportVisita(reportVisita)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        sendConfirmReport(context: UserContext, payload: { emailAzienda: string, emailTutor: string, tutorAziendale: string, tirocinante: string, dataVisita: string, tutorFormativo: string, activityType: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.sendConfirmReport(payload.emailAzienda, payload.emailTutor, payload.tutorAziendale, payload.tirocinante, payload.dataVisita, payload.tutorFormativo, payload.activityType)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        refuseReportVisita(context: UserContext, payload: { idReport: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.refuseReportVisita(payload.idReport)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        signReportVisita(context: UserContext, payload: { idReport: number, firmaTutorAziendale: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.signReportVisita(payload.idReport, payload.firmaTutorAziendale)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        signConsenso(context: UserContext, payload: { idConsenso: number, firma: string, soggetto: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.signConsenso(payload.idConsenso, payload.firma, payload.soggetto)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        confirmConsenso(context: UserContext, payload: { idConsenso: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.confirmConsenso(payload.idConsenso)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        refuseConsenso(context: UserContext, payload: { idConsenso: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.refuseConsenso(payload.idConsenso)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        sendEmailAssegnazioneAllievoAzienda(context: UserContext, payload: { denominazioneAzienda: string, tirocinante: string, emailAzienda: string, emailTirocinante: string, activityType: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.sendEmailAssegnazioneAllievoAzienda(payload.denominazioneAzienda, payload.tirocinante, payload.emailAzienda, payload.emailTirocinante, payload.activityType)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        sendEmailAbbinamentoCompletato(context: UserContext, payload: { emailTutorArticolazione: string, denominazioneAzienda: string, tirocinante: string, activityType: string, statusAccettazione: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.sendEmailAbbinamentoCompletato(payload.emailTutorArticolazione, payload.denominazioneAzienda, payload.tirocinante, payload.activityType, payload.statusAccettazione)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        sendEmailConfermaAllievoAlternanza(context: UserContext, payload: { emailAllievo: string, denominazioneAzienda: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.sendEmailConfermaAllievoAlternanza(payload.emailAllievo, payload.denominazioneAzienda)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        sendEmailDocGenerati(context: UserContext, payload: { emailAzienda: string, emailTirocinante: string, denominazioneAzienda: string, tirocinante: string, activityType: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.sendEmailDocGenerati(payload.emailAzienda, payload.emailTirocinante, payload.denominazioneAzienda, payload.tirocinante, payload.activityType)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        updatePreAssegnamentoTirFormativo(context: UserContext, payload: { dataInizioPeriodo: string, dataFinePeriodo: string, oraInizioMattino: string, oraFineMattino: string, oraInizioPomeriggio: string, oraFinePomeriggio: string, idTutorAziendale: number, facilitazioni: string, idRichiesta: number, attivita: string, responsabilitaCivile: string, assicurazioneAzienda: string, indennitaMensile: string, dataInizioSospensioneUno: string | null, dataFineSospensioneUno: string | null, motivazioneSospensioneUno: string, dataInizioSospensioneDue: string | null, dataFineSospensioneDue: string | null, motivazioneSospensioneDue: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.updatePreAssegnamentoTirFormativo(payload.dataInizioPeriodo, payload.dataFinePeriodo, payload.oraInizioMattino, payload.oraFineMattino, payload.oraInizioPomeriggio, payload.oraFinePomeriggio, payload.idTutorAziendale, payload.facilitazioni, payload.idRichiesta, payload.attivita, payload.responsabilitaCivile, payload.assicurazioneAzienda, payload.indennitaMensile, payload.dataInizioSospensioneUno, payload.dataFineSospensioneUno, payload.motivazioneSospensioneUno, payload.dataInizioSospensioneDue, payload.dataFineSospensioneDue, payload.motivazioneSospensioneDue)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        createAttestatoFinale(context: UserContext, infoAttestatoFinale: DocAttestatoFinale) {
            return new Promise<string>((resolve, reject) => {
                userService.createAttestatoFinale(infoAttestatoFinale)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        createQuestionario(context: UserContext, payload: { idRichiesta: number, activityType: string, tipoQuestionario: string, listaRisposte: any, note: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.createQuestionario(payload.idRichiesta, payload.activityType, payload.tipoQuestionario, payload.note).then(idQuestionario => {
                    payload.listaRisposte.forEach((risposta: any) => {
                        if (Array.isArray(risposta.risposta)) {
                            for (let i = 0; i < risposta.risposta.length; i++) {
                                userService.saveResponse(idQuestionario.Id, risposta.idDomanda, risposta.risposta[i], risposta.rispostaNota).then(() => {
                                    resolve("ok")
                                }).catch(error => {
                                    reject(error)
                                })
                            }
                        } else {
                            userService.saveResponse(idQuestionario.Id, risposta.idDomanda, risposta.risposta, risposta.rispostaNota).then(() => {
                                resolve("ok")
                            }).catch(error => {
                                reject(error)
                            })
                        }
                    });
                }).catch(error => {
                    reject(error)
                })
            })
        },
        changeStatusPeriodoIscrizioneAttivita(context: UserContext, payload: { idAttivita: number, statoIscrizione: boolean }) {
            return new Promise<string>((resolve, reject) => {
                userService.changeStatusPeriodoIscrizioneAttivita(payload.idAttivita, payload.statoIscrizione).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        editAttivitaIstituto(context: UserContext, attivitaIstituto: AttivitaIstituto) {
            return new Promise<string>((resolve, reject) => {
                userService.editAttivitaIstituto(attivitaIstituto).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        createAttivitaIstituto(context: UserContext, attivitaIstituto: AttivitaIstituto) {
            return new Promise<string>((resolve, reject) => {
                userService.createAttivitaIstituto(attivitaIstituto).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        assignTutorFormToRichiestaAlternanza(context: UserContext, payload: { idIstituto: number, idAnnoScolastico: number, idAllievo: number, idTutor: number, idTutorForm: number, idRichiesta: number, attivita: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.assignTutorFormToRichiestaAlternanza(payload.idIstituto, payload.idAnnoScolastico, payload.idAllievo, payload.idTutor, payload.idTutorForm, payload.idRichiesta, payload.attivita)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        signPercorsoFormativo(context: UserContext, payload: { idPercorsoFormativo: number, firma: string, firmaDue: string, firmaTutore: string, soggetto: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.signPercorsoFormativo(payload.idPercorsoFormativo, payload.firma, payload.firmaDue, payload.firmaTutore, payload.soggetto)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        refuseAssignment(context: UserContext, payload: { idRichiesta: number, activityType: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.refuseAssignment(payload.idRichiesta, payload.activityType).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        updatePreAssegnamentoTirReIns(context: UserContext, payload: { dataInizioPeriodo: string, dataFinePeriodo: string, oraInizioMattino: string, oraFineMattino: string, oraInizioPomeriggio: string, oraFinePomeriggio: string, idTutorAziendale: number, facilitazioni: string, idRichiesta: number, attivita: string, responsabilitaCivile: string, assicurazioneAzienda: string, indennitaMensile: string, dataInizioSospensioneUno: string | null, dataFineSospensioneUno: string | null, motivazioneSospensioneUno: string, dataInizioSospensioneDue: string | null, dataFineSospensioneDue: string | null, motivazioneSospensioneDue: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.updatePreAssegnamentoTirReIns(payload.dataInizioPeriodo, payload.dataFinePeriodo, payload.oraInizioMattino, payload.oraFineMattino, payload.oraInizioPomeriggio, payload.oraFinePomeriggio, payload.idTutorAziendale, payload.facilitazioni, payload.idRichiesta, payload.attivita, payload.responsabilitaCivile, payload.assicurazioneAzienda, payload.indennitaMensile, payload.dataInizioSospensioneUno, payload.dataFineSospensioneUno, payload.motivazioneSospensioneUno, payload.dataInizioSospensioneDue, payload.dataFineSospensioneDue, payload.motivazioneSospensioneDue)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        deletePreferenzaWorkshop(context: UserContext, idInformazione: number) {
            return new Promise<string>((resolve, reject) => {
                userService.deletePreferenzaWorkshop(idInformazione).then(() => {
                    resolve('ok')
                }).catch(error => {
                    reject(error)
                })
            })
        },
        updatePreferenzaWorkshop(context: UserContext, payload: { idInformazione: number, articolazione: string, scelta: string, nomeReferente: string, cognomeReferente: string, emailReferente: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.updatePreferenzaWorkshop(payload.idInformazione, payload.articolazione, payload.scelta, payload.nomeReferente, payload.cognomeReferente, payload.emailReferente).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        createPreferenzaWorkshop(context: UserContext, payload: { idIscrizioneAttivita: number, articolazione: string, scelta: string, nomeReferente: string, cognomeReferente: string, emailReferente: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.createPreferenzaWorkshop(payload.idIscrizioneAttivita, payload.articolazione, payload.scelta, payload.nomeReferente, payload.cognomeReferente, payload.emailReferente).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        createPropostaLavoro(context: UserContext, propostaLavoro: PropostaLavoroInfo) {
            return new Promise<string>((resolve, reject) => {
                userService.createPropostaLavoro(propostaLavoro).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        editPropostaLavoro(context: UserContext, propostaLavoro: PropostaLavoroInfo) {
            return new Promise<string>((resolve, reject) => {
                userService.editPropostaLavoro(propostaLavoro).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        creaCandidaturaLavoro(context: UserContext, payload: { idProposta: number, idAllievo: number, dataCandidatura: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.creaCandidaturaLavoro(payload.idProposta, payload.idAllievo, payload.dataCandidatura).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        sendCandidaturaLavoro(context: UserContext, payload: { emailContatto: string, allievo: string, istituto: string, nomeProposta: string }) {
            return new Promise<any>((resolve, reject) => {
                userService.sendCandidaturaLavoro(payload.emailContatto, payload.allievo, payload.istituto, payload.nomeProposta).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        changeStatusCandidatura(context: UserContext, payload: { idCandidatura: number, colloquioAvvenuto: boolean }) {
            return new Promise<any>((resolve, reject) => {
                userService.changeStatusCandidatura(payload.idCandidatura, payload.colloquioAvvenuto).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        changeStatusPresenzaWorkshop(context: UserContext, payload: { idInformazioneWorkshop: number, presenzaWorkshop: boolean }) {
            return new Promise<any>((resolve, reject) => {
                userService.changeStatusPresenzaWorkshop(payload.idInformazioneWorkshop, payload.presenzaWorkshop).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        addGiornoWorkshop(context: UserContext, payload: { idIstituto: number, idAnnoScolastico: number, giorno: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.addGiornoWorkshop(payload.idIstituto, payload.idAnnoScolastico, payload.giorno).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        deleteGiornoWorkshop(context: UserContext, payload: { idGiorno: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.deleteGiornoWorkshop(payload.idGiorno).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        editGiornoWorkshop(context: UserContext, payload: { idGiorno: number, giorno: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.editGiornoWorkshop(payload.idGiorno, payload.giorno).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        addTurnoWorkshop(context: UserContext, payload: { idIstituto: number, idAnnoScolastico: number, turno: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.addTurnoWorkshop(payload.idIstituto, payload.idAnnoScolastico, payload.turno).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        editTurnoWorkshop(context: UserContext, payload: { idTurno: number, turno: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.editTurnoWorkshop(payload.idTurno, payload.turno).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        deleteTurnoWorkshop(context: UserContext, payload: { idTurno: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.deleteTurnoWorkshop(payload.idTurno).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        saveScheduleWorkshop(context: UserContext, payload: { idInformazioneWorkshop: number, idTurno: number, idGiorno: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.saveScheduleWorkshop(payload.idInformazioneWorkshop, payload.idTurno, payload.idGiorno).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        deleteScheduleWorkshop(context: UserContext, payload: { idInformazioneWorkshop: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.deleteScheduleWorkshop(payload.idInformazioneWorkshop).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        uploadCV(context: UserContext, payload: { formData: FormData }) {
            // console.log(payload.formData)
            return new Promise<string>((resolve, reject) => {
                userService.uploadCV(payload.formData).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        deleteCandidatura(context: UserContext, payload: { idCandidatura: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.deleteCandidatura(payload.idCandidatura).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        deleteProposta(context: UserContext, payload: { idProposta: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.deleteProposta(payload.idProposta).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        createAllievo(context: UserContext, allievo: any) {
            return new Promise<string>((resolve, reject) => {
                userService.createAllievo(allievo).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        concludiAttivita(context: UserContext, payload: { idRichiesta: number, activityType: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.concludiAttivita(payload.idRichiesta, payload.activityType).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        createContattoAzienda(context: UserContext, nuovoContatto: ContattoAziendaInfo) {
            return new Promise<string>((resolve, reject) => {
                userService.createContattoAzienda(nuovoContatto).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        editContattoAzienda(context: UserContext, nuovoContatto: ContattoAziendaInfo) {
            return new Promise<string>((resolve, reject) => {
                userService.editContattoAzienda(nuovoContatto).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        deleteContattoAzienda(context: UserContext, payload: { idContatto: number, idIstituto: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.deleteContattoAzienda(payload.idContatto, payload.idIstituto).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        createNotaAzienda(context: UserContext, nuovaNota: NotaAzienda) {
            return new Promise<string>((resolve, reject) => {
                userService.createNotaAzienda(nuovaNota).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        editNotaAzienda(context: UserContext, nuovaNota: NotaAzienda) {
            return new Promise<string>((resolve, reject) => {
                userService.editNotaAzienda(nuovaNota).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })      
            })
        },
        deleteNotaAzienda(context: UserContext, payload: { idNota: number, idIstituto: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.deleteNotaAzienda(payload.idNota, payload.idIstituto).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        deletePreferenzaColloquio(context: UserContext, idInformazione: number) {
            return new Promise<string>((resolve, reject) => {
                userService.deletePreferenzaColloquio(idInformazione).then(() => {
                    resolve('ok')
                }).catch(error => {
                    reject(error)
                })
            })
        },
        createPreferenzaColloquio(context: UserContext, payload: { idIscrizioneAttivita: number, articolazione: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.createPreferenzaColloquio(payload.idIscrizioneAttivita, payload.articolazione).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        saveAssegnazioneAreaAzienda(context: UserContext, payload: { idInformazioneCV: number, idArea: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.saveAssegnazioneAreaAzienda(payload.idInformazioneCV, payload.idArea).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        saveAssegnazioneAreaAllievo(context: UserContext, payload: { idIscrizione: number, idArea: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.saveAssegnazioneAreaAllievo(payload.idIscrizione, payload.idArea).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        deleteAssegnazioneAreaAllievo(context: UserContext, payload: { idAssegnazione: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.deleteAssegnazioneAreaAllievo(payload.idAssegnazione).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        deleteIscrizioneAttivitaAllievo(context: UserContext, payload: { idIscrizioneAttivita: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.deleteIscrizioneAttivitaAllievo(payload.idIscrizioneAttivita).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        deleteAssegnazioneAreaAzienda(context: UserContext, payload: { idAssegnazione: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.deleteAssegnazioneAreaAzienda(payload.idAssegnazione).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        deleteAssociazioneAllievoAzienda(context: UserContext, payload: { idRichiesta: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.deleteAssociazioneAllievoAzienda(payload.idRichiesta).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        verificaUtente(context: UserContext, payload: { piva: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.verificaUtente(payload.piva).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        changeStatusPresenzaColloquio(context: UserContext, payload: { idColloquio: number, colloquioAvvenuto: boolean, soggetto: string }) {
            return new Promise<any>((resolve, reject) => {
                userService.changeStatusPresenzaColloquio(payload.idColloquio, payload.colloquioAvvenuto, payload.soggetto).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        changeStatusPubblicazioneAttivita(context: UserContext, payload: { idAttivita: number, statoPubblicazione: boolean }) {
            return new Promise<string>((resolve, reject) => {
                userService.changeStatusPubblicazioneAttivita(payload.idAttivita, payload.statoPubblicazione).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        deleteColloquioCV(context: UserContext, payload: { idColloquio: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.deleteColloquioCV(payload.idColloquio).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        changeTurnoColloquioCV(context: UserContext, payload: { idTurno: number, idColloquio: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.changeTurnoColloquioCV(payload.idTurno, payload.idColloquio).then(() => {
                    resolve("ok")
                }).catch(error => {
                    reject(error)
                })
            })
        },
        createGiornoFoglioFirme(context: UserContext, payload: { idRichiesta: number, activityType: string, dataFirma: string, orarioInizioMattina: string, orarioFineMattina: string, orarioInizioPomeriggio: string, orarioFinePomeriggio: string }) {
            return new Promise<string>((resolve, reject) =>{
                userService.createGiornoFoglioFirme(payload.idRichiesta,payload.activityType,payload.dataFirma,payload.orarioInizioMattina,payload.orarioFineMattina,payload.orarioInizioPomeriggio,payload.orarioFinePomeriggio).then(() =>{
                    resolve("ok")
                }).catch(error =>{
                    reject(error)
                })
            })
        },
        deleteGiornoFoglioFirme(context: UserContext, payload: { idFirma: number }){
            return new Promise<string>((resolve, reject) =>{
                userService.deleteGiornoFoglioFirme(payload.idFirma).then(() =>{
                    resolve("ok")
                }).catch(error =>{
                    reject(error)
                })
            })
        },
        changeCorsoSicurezzaStatus(context: UserContext, payload: { idUtente: number, statusCorso: boolean}){
            return new Promise<string>((resolve, reject) =>{
                userService.changeCorsoSicurezzaStatus(payload.idUtente,payload.statusCorso).then(() =>{
                    resolve("ok")
                }).catch(error =>{
                    reject(error)
                })
            })
        },
        acceptRichiestaAlternaza(context: UserContext, payload: { idRichiesta: number}){
            return new Promise<string>((resolve, reject) =>{
                userService.acceptRichiestaAlternaza(payload.idRichiesta).then(() =>{
                    resolve("ok")
                }).catch(error =>{
                    reject(error)
                })    
            })
        },
        refuseRichiestaAlternaza(context: UserContext, payload: { idRichiesta: number, note: string}){
            return new Promise<string>((resolve, reject) =>{
                userService.refuseRichiestaAlternaza(payload.idRichiesta, payload.note).then(() =>{
                    resolve("ok")
                }).catch(error =>{
                    reject(error)
                })    
            })    
        },
        createIspezione(context: UserContext, ispezione: any) {
            return new Promise<string>((resolve, reject) => {
                userService.createIspezione(ispezione)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        signIspezione(context: UserContext, payload: { idIspezione: number, firmaAzienda: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.signIspezione(payload.idIspezione, payload.firmaAzienda)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        refuseIspezione(context: UserContext, payload: { idIspezione: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.refuseIspezione(payload.idIspezione)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        uploadDocumento(context: UserContext, payload: { idTipoDocumento: number, idTipoAttivita: number, tipoAttivita: String, idRichiesta: number,base64: any }) {
            return new Promise<string>((resolve, reject) => {
                userService.uploadDocumento(payload.idTipoDocumento, payload.idTipoAttivita, payload.tipoAttivita, payload.idRichiesta, payload.base64)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        confermaConvenzioneAlternanza(context: UserContext, payload: { idConvenzione: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.confermaConvenzioneAlternanza(payload.idConvenzione)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        refuseConvenzioneAlternanza(context: UserContext, payload: { idConvenzione: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.refuseConvenzioneAlternanza(payload.idConvenzione)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        aggiornaProtocollazione(context: UserContext, payload: { idConvenzione: number, idPercorsoFormativo: number, numeroProtocollazione: string, dataProtocollazione: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.aggiornaProtocollazione(payload.idConvenzione, payload.idPercorsoFormativo, payload.numeroProtocollazione, payload.dataProtocollazione)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        confermaPercorsoFormativo(context: UserContext, payload: { idPercorsoFormativo: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.confermaPercorsoFormativo(payload.idPercorsoFormativo)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        rifiutaPercorsoFormativo(context: UserContext, payload: { idPercorsoFormativo: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.rifiutaPercorsoFormativo(payload.idPercorsoFormativo)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        sendEmailFirmaDocAlternanza(context: UserContext, payload: { emailAzienda: string, emailTirocinante: string, denominazioneAzienda: string, tirocinante: string, tipoSoggetto: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.sendEmailFirmaDocAlternanza(payload.emailAzienda, payload.emailTirocinante, payload.denominazioneAzienda, payload.tirocinante, payload.tipoSoggetto)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        editTirFormativo (context: UserContext, payload: { idRichiestaTirocinioFormativo: number, dataInizio: string, dataFine: string, idStatoAccettazione?: number }) {
            return new Promise<string>((resolve, reject) => {
                userService.editTirFormativo(payload.idRichiestaTirocinioFormativo, payload.dataInizio, payload.dataFine, payload.idStatoAccettazione)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        deleteAbbinamentoAlternanza(context: UserContext, idInfoAlternanza: number) {
            return new Promise<string>((resolve, reject) => {
                userService.deleteAbbinamentoAlternanza(idInfoAlternanza)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        uploadDocDVR(context: UserContext, payload: { base64: string, idRichiesta: number }) {
            return new Promise<any>((resolve, reject) =>{
                userService.uploadDocDVR(payload.base64, payload.idRichiesta)
                    .then(() =>{
                        resolve("ok")
                    }).catch(error =>{
                        reject(error)
                    })
            })
        },
        confirmDocDVR(context: UserContext, idDocumento: number) {
            return new Promise<any>((resolve, reject) =>{
                userService.confirmDocDVR(idDocumento)
                    .then(() =>{
                        resolve("ok")
                    }).catch(error =>{
                        reject(error)
                    })
            })
        },
        refuseDocDVR(context: UserContext, idDocumento: number) {
            return new Promise<any>((resolve, reject) =>{
                userService.refuseDocDVR(idDocumento)
                    .then(() =>{
                        resolve("ok")
                    }).catch(error =>{
                        reject(error)
                    })
            })
        },
        confirmOrariAllievo(context: UserContext, idInformazioneAlternanza: number) {
            return new Promise<string>((resolve, reject) => {
                userService.confirmOrariAllievo(idInformazioneAlternanza)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        refuseOrariAllievo(context: UserContext, idInformazioneAlternanza: number) {
            return new Promise<string>((resolve, reject) => {
                userService.refuseOrariAllievo(idInformazioneAlternanza)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        rateAlternanza(context: UserContext, payload: { idInformazioneAlternanza: number, rating: number, notaRating: string }) {
            return new Promise<string>((resolve, reject) => {
                userService.rateAlternanza(payload.idInformazioneAlternanza, payload.rating, payload.notaRating)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        createApprendistato(context: UserContext, apprendistato: any) {
            return new Promise<string>((resolve, reject) => {
                userService.createApprendistato(apprendistato)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        updateApprendistato(context: UserContext, apprendistato: any) {
            return new Promise<string>((resolve, reject) => {
                userService.updateApprendistato(apprendistato)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        deleteApprendistato(context: UserContext, idApprendistato: number) {
            return new Promise<string>((resolve, reject) => {
                userService.deleteApprendistato(idApprendistato)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        updateStatoPercorsoFormativo(context: UserContext, payload: { idPercorsoFormativo:number, idStatoFirmaAzienda?:number, idStatoFirmaTirocinante?:number, idStatoFirmaTutorArticolazione?:number }) {
            return new Promise<string>((resolve, reject) => {
                userService.updateStatoPercorsoFormativo(payload.idPercorsoFormativo, payload.idStatoFirmaAzienda, payload.idStatoFirmaTirocinante, payload.idStatoFirmaTutorArticolazione)
                    .then(() => {
                        resolve("ok")
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        // submitRichiestaAssistenza(context: UserContext, richiestaAssistenza: RichiestaAssistenza) {
        //     return new Promise<string>((resolve, reject) => {
        //         userService.submitRichiestaAssistenza(richiestaAssistenza)
        //             .then(() => {
        //                 resolve("ok")
        //             }).catch(error => {
        //                 reject(error)
        //             })
        //     })
        // }
    }
};

const { commit, read, dispatch } = getStoreAccessors<UserState, RootState>("user");
const getters = user.getters;

export const readUserInfo = read(getters.getUserInfo);
export const readEnterpriseInfo = read(getters.getEnterpriseInfo);
export const readInstituteInfo = read(getters.getInstituteInfo);
export const readStudentInfo = read(getters.getStudentInfo);

const actions = user.actions;

export const dispatchSetUserInfo = dispatch(actions.setUserInfo);
export const dispatchEditUserInfo = dispatch(actions.editUserInfo);
export const dispatchSetEnterpriseInfo = dispatch(actions.setEnterpriseInfo);
export const dispatchEditEnterpriseInfo = dispatch(actions.editEnterpriseInfo);
export const dispatchSetInstituteInfo = dispatch(actions.setInstituteInfo);
export const dispatchEditInstituteInfo = dispatch(actions.editInstituteInfo);
export const dispatchClearState = dispatch(actions.clearState);
export const dispatchSendResetLink = dispatch(actions.sendResetLink);
export const dispatchResetPassword = dispatch(actions.resetPassword);
export const dispatchCreateUser = dispatch(actions.createUser);
export const dispatchSetStudentInfo = dispatch(actions.setStudentInfo);
export const dispatchEditStudentInfo = dispatch(actions.editStudentInfo);
export const dispatchAuthorizationDoc = dispatch(actions.submitAuthorizationDoc);
export const dispatchResponsabileDatiDoc = dispatch(actions.submitResponsabileDatiDoc);
export const dispatchConfirmResponsabileDatiDoc = dispatch(actions.confirmResponsabileDatiDoc);
export const dispatchRefuseResponsabileDatiDoc = dispatch(actions.refuseResponsabileDatiDoc);
export const dispatchUpdateResponsabileDatiDoc = dispatch(actions.updateResponsabileDatiDoc);
export const dispatchConfirmAutorizzazioneStudentiDoc = dispatch(actions.confirmAutorizzazioneStudentiDoc);
export const dispatchRefuseAutorizzazioneStudentiDoc = dispatch(actions.refuseAutorizzazioneStudentiDoc);
export const dispatchUpdateAutorizzazioneStudentiDoc = dispatch(actions.updateAutorizzazioneStudentiDoc);
export const dispatchRichiestaAlternanza = dispatch(actions.submitRichiestaAlternanza);
export const dispatchSubscribeToActivities = dispatch(actions.subscribeToActivities);
export const dispatchSubscribeToAlternanza = dispatch(actions.subscribeToAlternanza);
export const dispatchRefuseDoc = dispatch(actions.refuseDoc)
export const dispatchConfirmDoc = dispatch(actions.confirmDoc)
export const dispatchDeleteRichiestaAlternanza = dispatch(actions.deleteRichiestaAlternanza)
export const dispatchUpdateRichiestaAlternanza = dispatch(actions.updateRichiestaAlternanza)
export const dispatchAddUserRole = dispatch(actions.addUserRole)
export const dispatchDeleteUserRole = dispatch(actions.deleteUserRole)
export const dispatchDeleteAssegnazioneIndirizzoStudio = dispatch(actions.deleteAssegnazioneIndirizzoStudio)
export const dispatchdDeleteAssegnazioneArticolazione = dispatch(actions.deleteAssegnazioneArticolazione)
export const dispatchUpdateUserRole = dispatch(actions.updateUserRole)
export const dispacthConfirmAssegnazioneIndirizzoStudio = dispatch(actions.confirmAssegnazioneIndirizzoStudio)
export const dispatchConfirmAssegnazioneArticolazione = dispatch(actions.confirmAssegnazioneArticolazione)
export const dispatchAssignTutorToAllievo = dispatch(actions.assignTutorToAllievo)
export const dispatchChangeStudentActivityStatus = dispatch(actions.changeStudentActivityStatus)
export const dispatchAssignAllievoToAzienda = dispatch(actions.assignAllievoToAzienda)
export const dispatchSubscribeToColloqui = dispatch(actions.subscribeToColloqui)
export const dispatchRegisterSchedule = dispatch(actions.registerSchedule)
export const dispatchSendQuestionarioCV = dispatch(actions.sendQuestionarioCV)
export const dispatchSendLinkColloquioCV = dispatch(actions.sendLinkColloquioCV)
export const dispatchSubscribeToTirEstivi = dispatch(actions.subscribeToTirEstivi)
export const dispatchSubmitRichiestaTirEstivo = dispatch(actions.submitRichiestaTirEstivo)
export const dispatchDeleteRichiestaTirEstivo = dispatch(actions.deleteRichiestaTirEstivo)
export const dispatchUpdateRichiestaTirEstivo = dispatch(actions.updateRichiestaTirEstivo)
export const dispatchAssignAllievoToAziendaTirEstivo = dispatch(actions.assignAllievoToAziendaTirEstivo)
export const dispatchUpdatePreAssegnamentoTirEstivo = dispatch(actions.updatePreAssegnamentoTirEstivo)
export const dispatchAssignTutorFormToRichiestaTirEstivo = dispatch(actions.assignTutorFormToRichiestaTirEstivo)
export const dispatchConfirmAbbinamento = dispatch(actions.confirmAbbinamento)
export const dispatchGeneraDocumenti = dispatch(actions.generaDocumenti)
export const dispatchSignConvenzione = dispatch(actions.signConvenzione)
export const dispatchSignProgettoOrientamento = dispatch(actions.signProgettoOrientamento)
export const dispatchConfirmConvenzione = dispatch(actions.confirmConvenzione)
export const dispatchRefuseConvenzione = dispatch(actions.refuseConvenzione)
export const dispatchConfirmProgettoOrientamento = dispatch(actions.confirmProgettoOrientamento)
export const dispatchRefuseProgettoOrientamento = dispatch(actions.refuseProgettoOrientamento)
export const dispatchSubscribeToTirFormativi = dispatch(actions.subscribeToTirFormativi)
export const dispatchSubmitRichiestaTirFormativo = dispatch(actions.submitRichiestaTirFormativo)
export const dispatchAssignAllievoToAziendaTirFormativo = dispatch(actions.assignAllievoToAziendaTirFormativo)
export const dispatchAssignTutorFormToRichiestaTirFormativo = dispatch(actions.assignTutorFormToRichiestaTirFormativo)
export const dispatchSaveAssegnazioneAllievoAzienda = dispatch(actions.saveAssegnazioneAllievoAzienda)
export const dispatchRefusePreAbbinamento = dispatch(actions.refusePreAbbinamento)
export const dispatchCreateReportVisita = dispatch(actions.createReportVisita)
export const dispatchSendConfirmReport = dispatch(actions.sendConfirmReport)
export const dispatchRefuseReportVisita = dispatch(actions.refuseReportVisita)
export const dispatchSignReportVisita = dispatch(actions.signReportVisita)
export const dispatchSignConsenso = dispatch(actions.signConsenso)
export const dispatchRefuseConsenso = dispatch(actions.refuseConsenso)
export const dispatchConfirmConsenso = dispatch(actions.confirmConsenso)
export const dispacthSendEmailAssegnazioneAllievoAzienda = dispatch(actions.sendEmailAssegnazioneAllievoAzienda)
export const dispatchSendEmailAbbinamentoCompletato = dispatch(actions.sendEmailAbbinamentoCompletato)
export const dispatchSendEmailConfermaAllievoAlternanza = dispatch(actions.sendEmailConfermaAllievoAlternanza)
export const dispatchSendEmailDocGenerati = dispatch(actions.sendEmailDocGenerati)
export const dispatchUpdatePreAssegnamentoTirFormativo = dispatch(actions.updatePreAssegnamentoTirFormativo)
export const dispatchCreateAttestatoFinale = dispatch(actions.createAttestatoFinale)
export const dispatchCreateQuestionario = dispatch(actions.createQuestionario)
export const dispatchChangeStatusPeriodoIscrizioneAttivita = dispatch(actions.changeStatusPeriodoIscrizioneAttivita)
export const dispatchEditAttivitaIstituto = dispatch(actions.editAttivitaIstituto)
export const dispatchCreateAttivitaIstituto = dispatch(actions.createAttivitaIstituto)
export const dispatchAssignTutorFormToRichiestaAlternanza = dispatch(actions.assignTutorFormToRichiestaAlternanza)
export const dispatchUpdatePreAssegnamentoAlternanza = dispatch(actions.updatePreAssegnamentoAlternanza)
export const dispatchSignPercorsoFormativo = dispatch(actions.signPercorsoFormativo)
export const dispatchConfirmPercorsoFormativo = dispatch(actions.confirmPercorsoFormativo)
export const dispatchRefusePercorsoFormativo = dispatch(actions.refusePercorsoFormativo)
export const dispatchRefuseAssignment = dispatch(actions.refuseAssignment)
export const dispatchUpdatePreAssegnamentoTirReIns = dispatch(actions.updatePreAssegnamentoTirReIns)
export const dispatchDeletePreferenzaWorkshop = dispatch(actions.deletePreferenzaWorkshop)
export const dispatchUpdatePreferenzaWorkshop = dispatch(actions.updatePreferenzaWorkshop)
export const dispatchCreatePreferenzaWorkshop = dispatch(actions.createPreferenzaWorkshop)
export const dispatchCreatePropostaLavoro = dispatch(actions.createPropostaLavoro)
export const dispatchEditPropostaLavoro = dispatch(actions.editPropostaLavoro)
export const dispatchCreaCandidaturaLavoro = dispatch(actions.creaCandidaturaLavoro)
export const dispatchSendCandidaturaLavoro = dispatch(actions.sendCandidaturaLavoro)
export const dispatchChangeStatusCandidatura = dispatch(actions.changeStatusCandidatura)
export const dispatchChangeStatusPresenzaWorkshop = dispatch(actions.changeStatusPresenzaWorkshop)
export const dispatchAddGiornoWorkshop = dispatch(actions.addGiornoWorkshop)
export const dispatchDeleteGiornoWorkshop = dispatch(actions.deleteGiornoWorkshop)
export const dispatchEditGiornoWorkshop = dispatch(actions.editGiornoWorkshop)
export const dispatchAddTurnoWorkshop = dispatch(actions.addTurnoWorkshop)
export const dispatchEditTurnoWorkshop = dispatch(actions.editTurnoWorkshop)
export const dispatchDeleteTurnoWorkshop = dispatch(actions.deleteTurnoWorkshop)
export const dispatchSaveScheduleWorkshop = dispatch(actions.saveScheduleWorkshop)
export const dispatchDeleteScheduleWorkshop = dispatch(actions.deleteScheduleWorkshop)
export const dispatchUploadCV = dispatch(actions.uploadCV)
export const dispatchDeleteCandidatura = dispatch(actions.deleteCandidatura)
export const dispatchDeleteProposta = dispatch(actions.deleteProposta)
export const dispacthCreateAllievo = dispatch(actions.createAllievo)
export const dispatchConcludiAttivita = dispatch(actions.concludiAttivita)
export const dispatchCreateContattoAzienda = dispatch(actions.createContattoAzienda)
export const dispatchEditContattoAzienda = dispatch(actions.editContattoAzienda)
export const dispatchDeleteContattoAzienda = dispatch(actions.deleteContattoAzienda)
export const dispatchCreateNotaAzienda = dispatch(actions.createNotaAzienda)
export const dispatchEditNotaAzienda = dispatch(actions.editNotaAzienda)
export const dispatchDeleteNotaAzienda = dispatch(actions.deleteNotaAzienda)
export const dispatchDeletePreferenzaColloquio = dispatch(actions.deletePreferenzaColloquio)
export const dispatchCreatePreferenzaColloquio = dispatch(actions.createPreferenzaColloquio)
export const dispatchSaveAssegnazioneAreaAzienda = dispatch(actions.saveAssegnazioneAreaAzienda)
export const dispatchSaveAssegnazioneAreaAllievo = dispatch(actions.saveAssegnazioneAreaAllievo)
export const dispatchDeleteAssegnazioneAreaAllievo = dispatch(actions.deleteAssegnazioneAreaAllievo)
export const dispatchDeleteAssegnazioneAreaAzienda = dispatch(actions.deleteAssegnazioneAreaAzienda)
export const dispatchDeleteAssociazioneAllievoAzienda = dispatch(actions.deleteAssociazioneAllievoAzienda)
export const dispatchVerificaUtente = dispatch(actions.verificaUtente)
export const dispatchChangeStatusPresenzaColloquio = dispatch(actions.changeStatusPresenzaColloquio)
export const dispatchChangeStatusPubblicazioneAttivita = dispatch(actions.changeStatusPubblicazioneAttivita)
export const dispatchDeleteColloquioCV = dispatch(actions.deleteColloquioCV)
export const dispatchChangeTurnoColloquioCV = dispatch(actions.changeTurnoColloquioCV)
export const dispatchCreateGiornoFoglioFirme = dispatch(actions.createGiornoFoglioFirme)
export const dispatchDeleteGiornoFoglioFirme = dispatch(actions.deleteGiornoFoglioFirme)
export const dispatchChangeCorsoSicurezzaStatus = dispatch(actions.changeCorsoSicurezzaStatus)
export const dispatchAcceptRichiestaAlternanza = dispatch(actions.acceptRichiestaAlternaza)
export const dispatchRefuseRichiestaAlternaza = dispatch(actions.refuseRichiestaAlternaza)
export const dispatchCreateIspezione = dispatch(actions.createIspezione)
export const dispatchSignIspezione = dispatch(actions.signIspezione)
export const dispatchRefuseIspezione = dispatch(actions.refuseIspezione)
export const dispatchUploadDocumento = dispatch(actions.uploadDocumento)
export const dispatchConfermaConvenzioneAlternanza = dispatch(actions.confermaConvenzioneAlternanza)
export const dispatchRefuseConvenzioneAlternanza = dispatch(actions.refuseConvenzioneAlternanza)
export const dispatchAggiornaProtocollazione = dispatch(actions.aggiornaProtocollazione)
export const dispatchConfermaPercorsoFormativo = dispatch(actions.confermaPercorsoFormativo)
export const dispatchRifiutaPercorsoFormativo = dispatch(actions.rifiutaPercorsoFormativo)
export const dispatchSendEmailFirmaDocAlternanza = dispatch(actions.sendEmailFirmaDocAlternanza)
export const dispatchEditTirFormativo = dispatch(actions.editTirFormativo)
export const dispatchDeleteAbbinamentoAlternanza = dispatch(actions.deleteAbbinamentoAlternanza);
export const dispatchUploadDocDVR = dispatch(actions.uploadDocDVR);
export const dispatchConfirmDocDVR = dispatch(actions.confirmDocDVR);
export const dispatchRefuseDocDVR = dispatch(actions.refuseDocDVR);
export const dispatchConfirmOrariAllievo = dispatch(actions.confirmOrariAllievo);
export const dispatchRefuseOrariAllievo = dispatch(actions.refuseOrariAllievo);
export const dispatchRateAlternanza = dispatch(actions.rateAlternanza);
export const dispatchCreateApprendistato = dispatch(actions.createApprendistato);
export const dispatchUpdateApprendistato = dispatch(actions.updateApprendistato);
export const dispatchDeleteApprendistato = dispatch(actions.deleteApprendistato);
export const dispatchUpdateStatoPercorsoFormativo = dispatch(actions.updateStatoPercorsoFormativo);
export const dispatchDeleteIscrizioneAttivitaAllievo = dispatch(actions.deleteIscrizioneAttivitaAllievo);

const mutations = user.mutations;

export const commitEditUserInfo = commit(mutations.editUserInfo);
export const commitSetUserInfo = commit(mutations.editUserInfo);
export const commitSetEnterpriseInfo = commit(mutations.editEnterpriseInfo);
export const commitEditEnterpriseInfo = commit(mutations.editEnterpriseInfo);
export const commitSetInstituteInfo = commit(mutations.editInstituteInfo);
export const commitEditInstituteInfo = commit(mutations.editInstituteInfo);
export const commitClearState = commit(mutations.clearState);
export const commitSetStudentInfo = commit(mutations.editStudentInfo);
export const commitEditStudentInfo = commit(mutations.editStudentInfo);